import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { RxUploadService } from '../rx-upload.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxUploadModule } from '../rx-upload.module';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxColModule } from '@nrwl/rx-col';
import { RxRowModule } from '@nrwl/rx-row';
import { RxUploadZoneComponent } from '@nrwl/rx-forms';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { RxUploadDirective } from '../rx-upload-directive/rx-upload.directive';
import { RxUploadZoneDirective } from '../rx-upload-zone/rx-upload-zone.directive';

@Component({
  selector: 'rx-upload-preview',
  templateUrl: './rx-upload-preview.component.html',
  styleUrls: ['./rx-upload-preview.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxButtonModule,
    RxIconModule,
    RxColModule,
    RxRowModule,
    Ng2ImgMaxModule,
    RxUploadZoneComponent,
    RxUploadZoneComponent,
    RxUploadZoneDirective,
    RxUploadDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RxUploaderPreviewComponent implements OnInit {
  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  @Input()
  public photoUrl: any; //string

  @Input()
  public disabled: any; //boolean

  @Input()
  public defaultImg: any; //string

  @Input()
  public appendKey = 'file';

  @Output()
  public fileUploaded = new EventEmitter<FormData>();

  @Output()
  public fileDeleted = new EventEmitter<null>();

  public fileToUpload: any | File | null = null;

  public isLoading = false;

  constructor(
    private _cd: ChangeDetectorRef,
    private _transformService: RxUploadService,
  ) {}

  public ngOnInit() {}

  public handleFileInput(files: File | any) {
    if (this.disabled || !files) {
      return;
    }

    this.fileToUpload = files[0];

    this.createFileForSaving();
    this.setupReader();
    this.isLoading = false;
  }

  public handleChangeInput() {
    this.isLoading = true;
  }

  public createFileForSaving() {
    const formData: FormData = new FormData();
    formData.append(this.appendKey, this.fileToUpload, this.fileToUpload.name);

    this.fileUploaded.emit(formData);
  }

  public setupReader() {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      this.photoUrl = e.target.result;
      this._cd.detectChanges();
    };

    reader.readAsDataURL(this.fileToUpload);
  }

  public deletePhoto() {
    this.fileToUpload = null;
    this.photoUrl = null;
    this.fileDeleted.emit(null);
  }
}
